<template>
  <router-link
    :to="linkDestination"
    exact-path
    :class="{ 'is-active': isActive, 'is-suggested': suggested }"
    :aria-label="accessibleName"
  >
    <i
      :class="route.icon"
      aria-hidden="true"
    />
    <span>{{ route.text }}</span>
    <small
      v-if="route.group"
      class="navigation-link__group"
    >{{ route.group }}</small>
    <span
      v-if="route.tag"
      class="chip"
    >Novidade</span>
    <kbd
      v-if="suggested"
      class="navigation-link__key"
      aria-hidden="true"
    >Enter</kbd>
  </router-link>
</template>

<script>
import { mapState } from 'vuex';

import { matchesRoute } from '@/utils/navigationMenu';

export default {
  name: 'NavigationLink',
  props: {
    route: {
      type: Object,
      required: true,
    },
    suggested: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    ...mapState({
      promoterID: (state) => state.user.userInfo.promoter_id,
    }),
    isFinanceiro() {
      return this.route.text === 'Financeiro';
    },
    linkDestination() {
      if (this.isFinanceiro) {
        return {
          name: 'promoters-commission',
          params: {
            id: this.promoterID ?? null,
          },
        };
      }
      return this.route.href;
    },
    accessibleName() {
      return this.route.group ? `${this.route.text}, ${this.route.group}` : this.route.text;
    },
    isActive() {
      return matchesRoute(this.route, this.$route.path);
    },
  },
};
</script>
